<script setup lang="ts">
import AppIcon from './AppIcon.vue'
import Picto from './Picto.vue'

defineProps<{
  /** Nom des fichiers d'icônes dans src/assets/icons/ (sans extension). */
  icons: readonly string[]
  label: string
  href: string
  /** Lien externe : ouvre dans un nouvel onglet. */
  external?: boolean
}>()
</script>

<template>
  <a
    :href="href"
    :target="external ? '_blank' : undefined"
    :rel="external ? 'noopener noreferrer' : undefined"
    class="choice-card"
  >
    <div class="choice-card__head">
      <span
        v-for="(icon, i) in icons"
        :key="icon + i"
        class="choice-card__tile"
        :style="{ marginLeft: i === 0 ? '0' : '-0.75rem', zIndex: icons.length - i }"
      >
        <Picto :name="icon" :size="40" />
      </span>
      <AppIcon name="chevron" :size="22" class="choice-card__arrow" />
    </div>
    <p class="choice-card__label">{{ label }}</p>
  </a>
</template>

<style scoped>
.choice-card {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  background: var(--color-white);
  border-radius: var(--radius-lg);
  padding: 1.5rem;
  font-size: 1.0625rem;
  font-weight: 600;
  line-height: 1.4;
  color: var(--color-chocolate);
  text-decoration: none;
  transition:
    transform var(--dur-base) var(--ease-spring),
    box-shadow var(--dur-base) var(--ease-out);
  border: 1px solid transparent;
}
.choice-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-md);
}

.choice-card__head {
  display: flex;
  align-items: center;
}
.choice-card__tile {
  display: grid;
  place-items: center;
  width: 3rem;
  height: 3rem;
  background: var(--color-cream);
  border: 2px solid var(--color-cream-soft);
  border-radius: var(--radius-xs);
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}
.choice-card__arrow {
  margin-left: auto;
  transform: rotate(-90deg);
  color: var(--color-chocolate);
  transition: transform var(--dur-base) var(--ease-out);
}
.choice-card:hover .choice-card__arrow {
  transform: rotate(-90deg) translateX(-3px);
}
.choice-card__label {
  text-wrap: balance;
}
</style>
